import { arrayToTree } from 'performant-array-to-tree';
import { uniqBy, initial, last, sortBy } from 'lodash';

// Recursive algorithm to reformat the nodes from performant-array-to-tree to our node structure
const structureTreeNodes = node => {
  if (node.children) {
    node.children = node.children.map(child => structureTreeNodes(child));
  }
  const newNode = {
    ...node.data,
    children: node.children
  };
  return newNode;
};

const fileArrayToTree = fileArray => {
  // used to store nodes that need to be created to contain directories.
  let directories = [];
  const directoryPaths = [];

  let newArray = fileArray.map(each => {
    const file = { ...each };

    // split the directory path into array.
    const pathArray = file.filePath.split('/');

    // the id of the parent directory is the file path itself
    file.parent = file.filePath;

    // add the current path to directory paths to generate directory nodes later
    directoryPaths.push(file.parent);

    // below we iterate through all subpaths in order to generate directory nodes for all parents. This will generate duplicates which need to be filtered later.
    for (let x = 0; x < pathArray.length; x++) {
      const directorySlice = pathArray.slice(0, x);
      directoryPaths.push(directorySlice.join('/'));
    }

    return file;
  });

  // Turn directory paths into nodes. This will generate duplicates which will need to be filtered later.
  directoryPaths.forEach(path => {
    const pathArray = path.split('/');
    const parentParent = initial(pathArray).join('/');

    directories.push({
      fileId: path,
      fileName: last(pathArray) || null,
      parent: parentParent || null,
      folder: true,
      open: true
    });
  });

  // filter the new directory nodes by the fileId (the file path) to remove duplicates
  directories = uniqBy(directories, 'fileId');

  // delete directories that don't have a name.
  directories = directories.filter(file => Boolean(file.fileName));

  // combine directory nodes with file nodes.
  newArray = newArray.concat(directories);

  newArray = sortBy(newArray, 'fileName');
  // use performant-array-to-tree library to convert to a tree based on parent.
  const tree = arrayToTree(newArray, { id: 'fileId', parentId: 'parent' });

  // traverse the tree recursively to reformat each node to match our structure, not performant-array-to-tree's ugly structure.
  return tree.map(file => structureTreeNodes(file));
};

export default fileArrayToTree;



// WEBPACK FOOTER //
// ./src/utility/fileArrayToTree.js